module.exports = __webpack_public_path__ + "static/media/Admsiion_List.20c8f5bc.png";